import { render } from "./change_bed_modal.vue?vue&type=template&id=f546e414&scoped=true"
import script from "./change_bed_modal.vue?vue&type=script&lang=js"
export * from "./change_bed_modal.vue?vue&type=script&lang=js"

import "./change_bed_modal.vue?vue&type=style&index=0&id=f546e414&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f546e414"]])

export default __exports__